<template>
  <v-container class="pa-0 d-flex flex-column gap-3">
    <!--  header --->
    <v-container class="pa-0 ma-0">
      <v-card-title class="pa-0 custom-title mb-2">{{ headerTitle }}</v-card-title>
      <v-card-text
        class="pa-0 text-body-2 grey--text text--darken-2"
        v-html="headerSubtitle"
      ></v-card-text>
    </v-container>

    <!--  login $ forget password section --->
    <v-form ref="login$forgetPassword" class="ma-0 pa-0">
      <!--  login --->
      <v-sheet
        v-if="
          !showOtpForm &&
          !showResetPassword &&
          !showSingUp &&
          !OTPVerifyStep &&
          !OTPResetPassword
        "
        class="pa-0 d-flex flex-column gap-3"
      >
        <!-- phone number to change pass button--->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-13">
          <v-text-field
            v-model="phone"
            outlined
            hide-details="auto"
            :label="$t('mobile')"
            placeholder="0912-12xxxx7"
            class="rtl-text"
            clearable
            height="42"
            :rules="[mobileFormatRule]"
          ></v-text-field>
          <v-text-field
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="showPassword = !showPassword"
            outlined
            hide-details="auto"
            :label="$t('password')"
            height="42"
            class="rtl-text"
            clearable
            @keydown.enter.prevent="login"
          ></v-text-field>
          <v-row class="justify-space-between align-center" dense no-gutters>
            <v-col cols="auto">
              <v-card-text class="pa-0 grey--text text--darken-3 text-body-2">
                {{ $t("forgetPassword") }}
              </v-card-text>
            </v-col>
            <v-col cols="auto">
              <v-card-text
                class="pa-0 blue--text text-body-2"
                style="cursor: pointer"
                @click="stepForgetPassword"
              >
                {{ $t("reset password") }}
              </v-card-text>
            </v-col>
          </v-row>
        </v-container>

        <!-- login button to  continue with OTP--->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
          <v-btn
            :loading="loading"
            color="primary"
            small
            height="42"
            class="white--text"
            @click="login"
          >
            {{ $t("Login") }}
          </v-btn>
          <v-btn
            class="blue--text text-body-2 text--darken-5"
            text
            style="cursor: pointer"
            @click="openOTP"
          >
            {{ $t("login with otp") }}
          </v-btn>
        </v-container>

        <!-- divider section to singUp button--->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
          <v-sheet class="d-flex align-center justify-center" color="transparent">
            <v-divider class="flex-grow-1"></v-divider>
            <v-card-subtitle class="pa-0 mx-4 grey--text text--darken-1 text-body-2">
              {{ $t("or") }}
            </v-card-subtitle>
            <v-divider class="flex-grow-1"></v-divider>
          </v-sheet>
          <v-btn
          outlined
          color="primary"
          small
          height="42"
          @click="routeToRegister"
          >
            {{ buttonText }}
          </v-btn>
        </v-container>
      </v-sheet>

      <!--  OTP forgetPassword step -->
      <v-sheet v-if="OTPResetPassword" class="pa-0 d-flex flex-column gap-3">
        <!--  send OTP code -->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-2">
          <v-text-field
            v-model="phone"
            outlined
            :label="$t('mobile')"
            clearable
            class="rtl-text"
            placeholder="0912-12xxxx7"
            hide-details="auto"
            height="42"
            :rules="[mobileFormatRule]"
            @keydown.enter.prevent="getOTPCodePassword"
          ></v-text-field>
          <div style="flex-grow: 1"></div>
          <v-btn
            :loading="loading"
            color="primary"
            small
            height="42"
            class="white--text"
            @click="getOTPCodePassword"
          >
            {{ $t("send code") }}
          </v-btn>
        </v-container>
      </v-sheet>

      <!--  forgetPassword step -->
      <v-sheet v-if="showResetPassword" class="pa-0 d-flex flex-column gap-2">
        <!-- set OTP feild -->
        <v-container class="pa-0 ma-0">
          <v-text-field
            v-model="OTPcode"
            outlined
            :label="$t('send otp')"
            class="rtl-text"
            maxlength="5"
            hide-details="auto"
            height="42"
            clearable
          ></v-text-field
        ></v-container>

        <!-- title & set new pass and retype pass -->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-13">
          <v-card-text
            v-html="$t('choose secure password')"
            class="pa-0 pt-2 text-body-2 grey--text text--darken-2"
          >
          </v-card-text>
          <v-text-field
            v-model="newPassword"
            outlined
            height="42"
            :label="$t('password')"
            class="rtl-text"
            hide-details="auto"
            autocomplete="new-password"
            clearable
          ></v-text-field>
          <v-text-field
            v-model="retypePassword"
            outlined
            :label="$t('repeat password')"
            class="rtl-text"
            hide-details="auto"
            clearable
            height="42"
            :rules="[confirmPasswordRule]"
            @keydown.enter.prevent="resetPassword"
          ></v-text-field
        ></v-container>

        <!-- pass rules section -->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-13">
          <div class="text-body-2">
            <div class="rule-line" :class="ruleClass(passwordChecks.length)">
              <v-icon x-small :color="iconColor(passwordChecks.length)">
                {{ iconName(passwordChecks.length) }}
              </v-icon>
              <v-card-text class="pa-0 m-0 text-body-2">
                {{ $t("min length 8") }}
              </v-card-text>
            </div>

            <div class="rule-line" :class="ruleClass(passwordChecks.upperLower)">
              <v-icon x-small :color="iconColor(passwordChecks.upperLower)">
                {{ iconName(passwordChecks.upperLower) }}
              </v-icon>
              <v-card-text class="pa-0 m-0 text-body-2">
                {{ $t("must include uppercase and lowercase") }}
              </v-card-text>
            </div>

            <div class="rule-line" :class="ruleClass(passwordChecks.number)">
              <v-icon x-small :color="iconColor(passwordChecks.number)">
                {{ iconName(passwordChecks.number) }}
              </v-icon>
              <v-card-text class="pa-0 m-0 text-body-2">
                {{ $t("must include number") }}
              </v-card-text>
            </div>

            <div class="rule-line" :class="ruleClass(passwordChecks.symbol)">
              <v-icon x-small :color="iconColor(passwordChecks.symbol)">
                {{ iconName(passwordChecks.symbol) }}
              </v-icon>
              <v-card-text class="pa-0 ma-0 text-body-2">
                {{ $t("must include symbol") }}
              </v-card-text>
            </div>
          </div>
        </v-container>

        <!-- resend OTP -->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-13">
          <v-row class="d-flex justify-space-between align-center" dense no-gutters>
            <v-col cols="auto">
              <v-card-text class="pa-0 grey--text text--darken-3 text-body-2">
                {{ $t("resend code again") }}
              </v-card-text>
            </v-col>
            <v-col cols="auto">
              <v-btn
                outlined
                color="primary"
                depressed
                height="42"
                :disabled="timer > 0"
                @click="resendOTP"
              >
                {{ otpButtonText }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <!-- edit number -->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-13">
          <v-row class="d-flex justify-space-between align-center" dense no-gutters>
            <v-col cols="auto">
              <v-card-text class="pa-0 grey--text text--darken-3 text-body-2">
                {{ $t("wrong number") }}
              </v-card-text>
            </v-col>
            <v-col cols="auto">
              <v-card-text
                class="pa-0 primary--text text-body-2"
                style="cursor: pointer"
                @click="EditPhonePass"
              >
                {{ $t("edit phone number") }}
              </v-card-text>
            </v-col>
          </v-row>
        </v-container>

        <!-- confrim pass btn  -->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-13">
          <v-btn
            :loading="loading"
            color="primary"
            small
            height="42"
            class="white--text"
            @click="resetPassword"
          >
            {{ $t("confirm new password") }}
          </v-btn>
        </v-container>
      </v-sheet>
    </v-form>

    <!-- OTP  section--->
    <v-form class="ma-0 pa-0">
      <!-- send OTP code & back to login--->
      <v-sheet v-if="showOtpForm" class="pa-0 d-flex flex-column gap-3">
        <!-- phone number to back to login--->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
          <v-text-field
            v-model="phone"
            outlined
            height="42"
            :label="$t('mobile')"
            clearable
            class="rtl-text"
            placeholder="0912-12xxxx7"
            hide-details="auto"
            :rules="[mobileFormatRule]"
            @keydown.enter.prevent="getOTPCode"
          ></v-text-field>
          <v-btn
            :loading="loading"
            color="primary"
            small
            height="42"
            class="white--text"
            @click="getOTPCode"
          >
            {{ $t("send code") }}
          </v-btn>
          <v-btn
            class="pa-0 blue--text text-body-2"
            text
            style="cursor: pointer"
            @click="returnToLogin"
          >
            {{ $t("login with fixed password") }}
          </v-btn>
        </v-container>
        <!-- divider section to singUp button--->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
          <v-sheet class="d-flex align-center justify-center" color="transparent">
            <v-divider class="flex-grow-1"></v-divider>
            <v-card-subtitle class="pa-0 mx-4 grey--text text--darken-1 text-body-2">
              {{ $t("or") }}
            </v-card-subtitle>
            <v-divider class="flex-grow-1"></v-divider>
          </v-sheet>
          <v-btn outlined color="primary" small height="42" @click="routeToRegister">
            {{ buttonText }}
          </v-btn>
        </v-container>
      </v-sheet>
      <!-- resend OTP code & login --->
      <v-sheet v-if="OTPVerifyStep" class="pa-0 d-flex flex-column flex-grow-1 gap-3">
        <!-- set OTP code & resend --->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
          <v-text-field
            v-model="OTPcode"
            outlined
            :label="$t('send otp')"
            class="rtl-text"
            hide-details="auto"
            height="42"
            clearable
            @keydown.enter.prevent="confirmOTP()"
          ></v-text-field>
          <v-row class="d-flex justify-space-between align-center" dense no-gutters>
            <v-col cols="auto">
              <v-card-text class="pa-0 grey--text text--darken-3 text-body-2">
                {{ $t("resend code again") }}
              </v-card-text>
            </v-col>
            <v-col cols="auto">
              <v-btn
                outlined
                color="primary"
                height="42"
                depressed
                :disabled="timer > 0"
                @click="resendOTP"
              >
                {{ otpButtonText }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <!-- edit number -->
        <v-container class="pa-0 ma-0 d-flex flex-column">
          <v-row class="d-flex justify-space-between align-center" dense no-gutters>
            <v-col cols="auto">
              <v-card-text class="pa-0 grey--text text--darken-3 text-body-2">
                {{ $t("wrong number") }}
              </v-card-text>
            </v-col>
            <v-col cols="auto">
              <v-card-text
                class="pa-0 blue--text text-body-2"
                style="cursor: pointer"
                @click="EditPhone"
              >
                {{ $t("edit phone number") }}
              </v-card-text>
            </v-col>
          </v-row>
        </v-container>

        <!-- login -->
        <v-container class="pa-0 ma-0 d-flex flex-column">
          <v-btn
            :loading="loading"
            color="primary"
            small
            height="42"
            class="white--text"
            @click="confirmOTP()"
          >
            {{ $t("Login") }}
          </v-btn>
        </v-container>
      </v-sheet>
    </v-form>

    <!--  footer --->
    <v-card-text v-if="!showResetPassword" class="pa-0 ma-0 text-center grey--text text--darken-1 text-body-2">
      {{ $t("login terms&condition") }}
      <a href="#" class="primary--text text-decoration-none">
        {{ $t("terms of use") }}
      </a>
      {{ $t("terms of service and policy") }}
      <a href="#" class="primary--text text-decoration-none"></a>
      {{ $t("abriron is") }}
    </v-card-text>

    <!--  snackbar --->
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :loading="loading"
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import General from '@/Mixins/general'

export default {
  name: 'LoginForm',
  components: {},
  mixins: [General],
  props: {
    SingUpSection: Boolean
  },
  data: () => ({
    loading: false,
    phone: '',
    password: '',
    newPassword: '',
    retypePassword: '',
    OTPcode: '',
    showSingUp: false,
    showOtpForm: false,
    showPassword: false,
    OTPVerifyStep: false,
    OTPResetPassword: false,
    showResetPassword: false,
    mobileFormatRule: null,
    timer: 120,
    snakbar: false,
    snakbarColor: null,
    snakbarText: null,
    userData: []
  }),
  created () {
    this.mobileFormatRule = (value) => {
      const regex = /^(\+98|0)?9\d{9}$/
      return regex.test(value) ? true : this.$t('invalid mobile format')
    }
  },
  computed: {
    passwordChecks () {
      const pass = this.newPassword || ''
      return {
        length: pass.length >= 8,
        upperLower: /[A-Z]/.test(pass) && /[a-z]/.test(pass),
        number: /\d/.test(pass),
        symbol: /[^A-Za-z0-9]/.test(pass)
      }
    },
    confirmPasswordRule () {
      return (value) => {
        return value === this.newPassword ? true : this.$t('passwords not match')
      }
    },
    formattedTime () {
      const minutes = Math.floor(this.timer / 60)
      const seconds = this.timer % 60
      return `${minutes.toString().padStart(2, '0')}:${seconds
        .toString()
        .padStart(2, '0')}`
    },
    otpButtonText () {
      return this.timer > 0 ? this.formattedTime : this.$t('Resend')
    },
    headerTitle () {
      if (this.showSingUp) return this.$t('register')
      if (this.showResetPassword || this.OTPResetPassword) { return this.$t('reset password') }
      if (this.OTPVerifyStep) return this.$t('verify phone')
      return this.$t('Login')
    },
    headerSubtitle () {
      if (this.OTPResetPassword) return this.$t('if account exists send code')
      if (this.OTPVerifyStep || this.showResetPassword) {
        return this.$t('verification code sent').replace(
          '<strong></strong>',
          `<strong>${this.phone}</strong>`
        )
      }
      return this.$t('')
    },
    buttonText () {
      if (this.showSingUp) return this.$t('log in')
      return this.$t('please register')
    }
  },
  methods: {
    ruleClass (isValid) {
      if (isValid) return 'rule--valid'
      if (this.newPassword.length > 0) return 'rule--invalid'
      return 'rule--neutral'
    },
    iconColor (isValid) {
      if (isValid) return 'green'
      if (this.newPassword.length > 0) return 'red'
      return 'grey'
    },
    iconName (isValid) {
      if (isValid) return 'mdi-check'
      if (this.newPassword.length > 0) return 'mdi-close'
      return 'mdi-circle'
    },
    login () {
      const valid = this.mobileFormatRule(this.phone)
      if (valid !== true) return
      var app = this
      app.loading = true
      this.$axios
        .post(this.$apipoint + 'v2/login', {
          username: this.phone,
          password: this.password
        })
        .then((response) => {
          // localStorage.setItem('user', response.data.meta)
          localStorage.setItem('hasaccount', response.data.meta.has_account)
          localStorage.setItem('usermobile', response.data.username)
          localStorage.setItem('primaryToken', JSON.stringify(response.data.meta.token))
          app.$axios.defaults.headers.common.x_api_key = response.data.meta.token
          const lastPath = localStorage.getItem('last_path')
          if (lastPath && lastPath !== 'null' && location.host !== 'app.abriron.com') {
            localStorage.setItem('last_path', null)
            app.$router.push({ path: lastPath })
          } else {
            if (app.$route.name === 'mlogin' || app.$route.name === 'mlogout') {
              // localStorage.setItem("apn", "active");
              // app.$router.push({ name: "mDashboard" });
            } else {
              localStorage.setItem('apn', null)
              if (response.data.meta.has_account == true) {
                // set (name + username + avatar) in vuex for showing user data
                app.$store.commit('SET_NAME', response.data.name)
                app.$store.commit('SET_AVATAR', response.data.avatar ? response.data.avatar : null)
                app.$store.commit('SET_USERNAME', response.data.username)
                this.getAccount(response)
              } else {
                app.$router.push('/business-Info')
              }
            }
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err)
          app.loading = false
        })
        .finally(() => {
          app.overlay = false
        })
    },
    stepForgetPassword () {
      this.OTPResetPassword = true
      this.showOtpForm = false
    },
    getOTPCodePassword () {
      var app = this
      app.loading = true
      const valid = this.mobileFormatRule(this.phone)
      if (valid !== true) {
        app.loading = false
        return
      }
      this.$axios
        .post(this.$apipoint + 'v2/otp/send', {
          mobile: this.phone,
          type: 'reset_password'
        })
        .then((response) => {
          this.OTPResetPassword = false
          this.showResetPassword = true
          this.startTimer()
        })
        .catch((err) => {
          app.loading = false
          app.serverErrorHandeler(err)
        })
        .finally(() => {
          app.loading = false
          app.overlay = false
        })
    },
    // confirmChangePassword() {
    //   var app = this;
    //   app.loading = true;
    //   this.$axios
    //     .post(this.$apipoint + "v2/otp/validate", {
    //       mobile: this.phone,
    //       code: this.OTPcode,
    //       type: 'validateOtp',
    //     })
    //     .then((response) => {
    //       localStorage.setItem("primaryToken", JSON.stringify(response.data.meta.token));
    //       app.$axios.defaults.headers.common.x_api_key = response.data.meta.token;
    //       this.resetPassword(response.data.meta.token);
    //     })
    //     .catch((err) => {
    //       app.loading = false;
    //       app.serverErrorHandeler(err);
    //     })
    //     .finally(() => {
    //       app.overlay = false;
    //     });
    // },
    resetPassword () {
      var app = this
      app.loading = true
      const valid =
        app.passwordChecks.length &&
        app.passwordChecks.upperLower &&
        app.passwordChecks.number &&
        app.passwordChecks.symbol
      if (!valid) return
      app.$axios
        .post(app.$apipoint + 'v2/reset-password',
          {
            mobile: app.phone,
            password: app.newPassword,
            code: app.OTPcode
          }
        )
        .then((response) => {
          app.showResetPassword = false
        })
        .catch((err) => {
          app.loading = false
          app.serverErrorHandeler(err)
        })
        .finally(() => {
          app.loading = false
          app.overlay = false
        })
    },
    returnToLogin () {
      this.showOtpForm = false
    },
    openOTP () {
      this.showOtpForm = true
      this.showResetPassword = false
    },
    goSignup () {
      this.showOtpForm = false
      this.showResetPassword = false
    },
    startTimer () {
      this.timer = 120
      const countdown = setInterval(() => {
        if (this.timer > 0) {
          this.timer--
        } else {
          clearInterval(countdown)
        }
      }, 1000)
    },
    getOTPCode () {
      var app = this
      app.loading = true
      const valid = this.mobileFormatRule(this.phone)
      if (valid !== true) {
        app.loading = false
        return
      }
      this.$axios
        .post(this.$apipoint + 'v2/otp/send', {
          mobile: this.phone
        })
        .then((response) => {
          this.OTPVerifyStep = true
          this.showOtpForm = false
          this.showResetPassword = false
          this.startTimer()
        })
        .catch((err) => {
          app.loading = false
          app.serverErrorHandeler(err)
        })
        .finally(() => {
          app.loading = false
          app.overlay = false
        })
    },
    confirmOTP () {
      var app = this
      app.loading = true
      this.$axios
        .post(this.$apipoint + 'v2/otp/validate', {
          mobile: this.phone,
          code: this.OTPcode,
          type: 'loginByOtp'
        })
        .then((response) => {
          // localStorage.setItem('user', response.data.meta)
          localStorage.setItem('hasaccount', response.data.meta.has_account)
          localStorage.setItem('usermobile', response.data.username)
          localStorage.setItem('primaryToken', JSON.stringify(response.data.meta.token))
          app.$axios.defaults.headers.common.x_api_key = response.data.meta.token
          const lastPath = localStorage.getItem('last_path')
          if (lastPath && lastPath !== 'null' && location.host !== 'app.abriron.com') {
            localStorage.setItem('last_path', null)
            app.$router.push({ path: lastPath })
          } else {
            if (app.$route.name === 'mlogin' || app.$route.name === 'mlogout') {
              // localStorage.setItem("apn", "active");
              // app.$router.push({ name: "mDashboard" });
            } else {
              localStorage.setItem('apn', null)
              if (response.data.meta.has_account == true) {
                // set (name + username + avatar) in vuex for showing user data
                app.$store.commit('SET_NAME', response.data.name)
                app.$store.commit('SET_AVATAR', response.data.avatar ? response.data.avatar : null)
                app.$store.commit('SET_USERNAME', response.data.username)
                this.getAccount(response)
              } else if (response.data.meta.has_account == false) {
                app.$router.push('/business-Info')
              } else {
                app.$router.push('/login')
              }
            }
          }
        })
        .catch((err) => {
          app.loading = false
          this.serverErrorHandeler(err)
        })
        .finally(() => {
          // app.loading = false;
          app.overlay = false
        })
    },
    EditPhone () {
      this.OTPVerifyStep = false
      this.showOtpForm = true
    },
    EditPhonePass () {
      this.showResetPassword = false
      this.OTPResetPassword = true
    },
    routeToRegister () {
      this.$emit('update:signUpSection', true)
      this.$emit('switchMode', true)
    },
    resendOTP () {
      if (this.timer === 0) {
        if (this.OTPVerifyStep) {
          this.getOTPCode()
        } else {
          this.getOTPCodePassword()
        }
        this.startTimer()
      }
    },
    getAccount (value) {
      var app = this
      app.loading = true
      app.$axios
        .post(app.$apipoint + 'v2/get-user-accounts', {
          headers: {
            x_api_key: value.data.meta.token
          }
        })
        .then((response) => {
          app.$emit('business-selector', {
            hasAccount: value.data.meta.has_account,
            Authorization: value.data.meta.token,
            userData: response.data.accounts
          })
        })
        .catch((err) => {
          app.loading = false
          app.serverErrorHandeler(err)
        })
        .finally(() => {
          app.overlay = false
          app.loading = false
        })
    }
  }
}
</script>

<style scoped>
::v-deep .v-label {
  top: 10px !important;
}
::v-deep .v-label.v-label--active  {
  top: 18px !important;
}
.v-text-field--enclosed .v-input__append-inner {
  margin-top: 10px;
}
.rule-line {
  display: flex;
  align-items: center;
  gap: 6px;
  transition: color 0.3s;
}
.rule--valid {
  color: #2e7d32;
}
.rule--invalid {
  color: #c62828;
}
.rule--neutral {
  color: gray;
}
.custom-title {
  font-weight: 600;
  font-size: 22px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
}
.v-text-field__details {
  margin: 0px;
  display: flex;
  flex: 1 0 auto;
}
</style>
